import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons'
// import DeleteModalToast from './delete';

import VerticalPrimeTable from '../../common/DataTable/verticalPrimeTable';
// import Pencil from 'apollo-react-icons/Pencil';
// import Trash from 'apollo-react-icons/Trash';

const UserDetails = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [t] = useTranslation();
  // const [showSubComponent, setShowSubComponent] = useState(false);
  // const [selectedData, setSelectedData] = useState({});
  // const [setShowModal] = useState(false);

  // const handleShowModal = (id, username) => {
  //   setSelectedData({ id, username });
  //   setShowSubComponent(true);
  // };

  // const handleSubComponentEvent = () => {
  //   console.log('Event triggered inside SubComponent!');
  // };

  // const handleConfirm = () => {
  //   // setShowModal(false);
  //   setShowSubComponent(false);

  // }

  useEffect(() => {
    const fetchUser = async () => {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${id}`, { withCredentials: true })
					.catch((err) => console.log(err));

      setUser(response.data);
    };
    
    fetchUser();
  }, [id]);
  if (!user) return <p>{t('Loading...')}</p>;

// const actions = [
//   {
//     label: "Edit",
//     element: (
//       <Link to={`/admin/users/edit/${user.id}`}><Pencil style={{color: "#198754",}} /></Link>
//     ),
//   },
//   {
//     label: "Delete",
//     element: (
//       <Link onClick={() => handleShowModal(user.id, user.username)}><Trash style={{color: "#ff0000",}} /></Link>
//     ),
//   },
// ];

  return (
    <div className="container mt-4 col-md-8" >
      <VerticalPrimeTable data={user}/> {/*  actions={actions} */}

      {/* {showSubComponent && (
        <DeleteModalToast sentData={selectedData} onEvent={handleSubComponentEvent} onConfirm={handleConfirm} />
      )} */}
    </div>

    // <div className="content">
    //   <p>{t('Username')} : {user.username}</p>
    //   <p>{t('Email')} : {user.email}</p>
    //   {/* <p>Group: {user.Group.name}</p> */}
    //   <p>{t('Role')} : {user.Role.name}</p>
    // </div>
  );
};

export default UserDetails;